import { Card } from 'antd';
import useTranslate from '@root/core/hooks/useTranslate';
import TableInbound from '../components/TableInbound';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import '../../../../../src/styles/pages/warehouse/_inbound/_index.scss';
const Breadcrumb = [
  {
    tittle: 'Inbound ',
    url: ''
  },
  {
    tittle: 'Inbound List',
    url: ''
  }
];
const InboundHome = () => {
  const [t] = useTranslate();
  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <TableInbound />
        </Card>
      </div>
    </>
  );
};

export default InboundHome;
